/** @format */
import { useAppTranslation } from '@/i18n/declarations';
import moment from 'moment';
import { RoomAvailability } from '../../bookingNew/types';
import React, { useMemo } from 'react';

interface UseAvailabilityProps {
  availableFrom?: string;
  roomAvailability: RoomAvailability;
}

const useAvailability = ({ availableFrom, roomAvailability }: UseAvailabilityProps) => {
  const { t, intl } = useAppTranslation();

  const availabilityText = useMemo(() => {
    if (!roomAvailability?.availableFrom || availableFrom === 'notAvailable' || roomAvailability?.negotiating) {
      return (
        <p>
          <span>{t('recently_booked')}</span>
        </p>
      );
    }

    const cleanedAvailabilityFrom = moment(roomAvailability?.availableFrom).utcOffset(2).set({ hour: 12 }).toDate();

    if (moment(cleanedAvailabilityFrom).isSame(moment(), 'day')) {
      return (
        <p className="green">
          {t('from')} <span className="today">{t('today')}</span>
        </p>
      );
    }

    const momentFormattedFromAvailability = intl.formatDate(roomAvailability?.availableFrom, {
      year: '2-digit',
      month: 'short',
      day: '2-digit',
    });

    return (
      <p>
        {t('from')} <span>{momentFormattedFromAvailability.toString()}</span>
      </p>
    );
  }, [roomAvailability, availableFrom, t, intl]);

  return {
    availabilityText,
  };
};

export default useAvailability;
